/*
 * @Author: atdow
 * @Date: 2024-11-04 17:37:13
 * @LastEditors: null
 * @LastEditTime: 2024-11-21 11:49:12
 * @Description: file description
 */

export const getViewport = function () {
  const win = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    w = win.innerWidth || e.clientWidth || g.clientWidth,
    h = win.innerHeight || e.clientHeight || g.clientHeight

  return { width: w, height: h }
}

export const relativePosition = function (element: HTMLElement, target: HTMLElement, topGap = 0) {
  // const elementDimensions = element.offsetParent
  //   ? { width: element.offsetWidth, height: element.offsetHeight }
  //   : this.getHiddenElementDimensions(element)
  const elementDimensions = { width: element.offsetWidth, height: element.offsetHeight }

  const targetHeight = target.offsetHeight
  const targetOffset = target.getBoundingClientRect()
  const viewport = getViewport()
  let top = 0
  let left = 0

  // 上下位置
  if (targetOffset.top + targetHeight + elementDimensions.height > viewport.height) {
    top = -1 * elementDimensions.height
    element.style.transformOrigin = 'bottom'
    if (targetOffset.top + top < 0) {
      top = -1 * targetOffset.top
    }
  } else {
    top = targetHeight
    element.style.transformOrigin = 'top'
  }

  if (top > 0) {
    element.style.top = top + topGap + 'px'
  } else {
    element.style.top = top - topGap + 'px'
  }

  // 左右位置
  if (elementDimensions.width > viewport.width) {
    // element wider then viewport and cannot fit on screen (align at left side of viewport)
    left = targetOffset.left * -1
  } else if (targetOffset.left + elementDimensions.width > viewport.width) {
    // element wider then viewport but can be fit on screen (align at right side of viewport)
    left = (targetOffset.left + elementDimensions.width - viewport.width) * -1
  } else {
    // element fits on screen (align with target)
    left = 0
  }

  element.style.left = left + 'px'
}
